export const FILTER_MEDS = 'context.FILTER_MEDS';
export const RESET_FILTERS = 'context.RESET_FILTERS';
export const SET_SORT = 'context.SET_SORT';
export const UPDATE_MED = 'context.UPDATE_MED';
export const UPDATE_MEDS = 'context.UPDATE_MEDS';
export const ONLY_NEED_APPROVAL = 'context.ONLY_NEED_APPROVAL';
export const SET_ERROR_MODAL = 'context.SET_ERROR_MODAL';
export const SET_MOBILE_EDITABLE = 'context.SET_MOBILE_EDITABLE';
export const SET_DIMENSIONS = 'context.SET_DIMENSIONS';
export const ByDoc = 'byDoc';
export const MILLISECONDS_IN_DAY = 86400000;
export const NUMBER_OF_DAYS_FOR_UNRECONCILED_MEDS = 16;
export const MEDS_ORDER_TYPE_VERBAL = 'verbal';
export const MEDS_ORDER_TYPE_ADMISSION = 'admit';
export const ADD = 'add';
export const REMOVE = 'remove';
export const COMPLETE = 'complete';
export const DOCTOR_ROLE_LIST = ['MDR', 'MD', 'NP', 'DO', 'PA'];
export const ERROR = 'error';
export const ERR_MSG =
  'Parameter preparerusername was not passed to the function';
export const PENDING_PRESCRIPTION = 'pending prescriptions';
export const PRESCRIPTIONS_KEY = 'prescriptions';
export const ACTIVE_KEY = 'active';
export const STOPPED_KEY = 'stopped';
export const DELETED_KEY = 'deleted';

// Header count based on lengh of expanded widget headCells length in ColHeaders.js
export const HEADER_CELL_COUNT = 15;
